import { ShieldCheck } from "lucide-react";

export function Footer({ supportUrl }: { supportUrl: string }) {
  return (
    <footer className="site-footer">
      <div className="footer__promise">
        <span className="footer__shield" aria-hidden="true">
          <ShieldCheck />
        </span>
        <div>
          <strong>Una valvola di sfogo, non un’arma.</strong>
          <p>Niente invii anonimi. Si scherza sulla situazione, non sulle persone.</p>
        </div>
      </div>
      <nav aria-label="Pagine informative">
        <a href="/privacy">Privacy</a>
        <a href="/termini">Termini</a>
        <a href="/cookie">Cookie</a>
        <a href={supportUrl}>Contatti</a>
      </nav>
      <a className="footer__credit" href={supportUrl}>by Free Future Lda</a>
    </footer>
  );
}
